import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search as SearchIcon, Phone, Mail, MapPin, Loader2, ChevronRight } from "lucide-react";
import { proApi } from "@/lib/proApi";
import { fmtDateTime } from "@/lib/api";

const ProSearch = () => {
  const nav = useNavigate();
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);

  const run = async (e) => {
    e.preventDefault();
    if (q.trim().length < 2) return;
    setLoading(true); setSearched(true);
    try {
      const { data } = await proApi.get("/pro/search", { params: { q } });
      setResults(data.results || []);
    } catch { setResults([]); } finally { setLoading(false); }
  };

  return (
    <div data-testid="pro-search-page">
      <h1 className="font-heading text-3xl md:text-4xl uppercase tracking-tight mb-2">Teilnehmer suchen</h1>
      <p className="text-neutral-500 text-sm mb-5">Suche nach Name, E-Mail oder Telefonnummer.</p>
      <form onSubmit={run} className="flex gap-2 mb-6 max-w-xl">
        <div className="relative flex-1">
          <SearchIcon size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-neutral-500" />
          <input data-testid="pro-search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Name, E-Mail oder Telefon…"
            className="w-full bg-[#1A1A1A] border border-white/10 text-white pl-9 pr-3 py-3 focus:border-[#ff0033] outline-none text-sm" />
        </div>
        <button type="submit" data-testid="pro-search-submit" className="bg-[#ff0033] text-white font-heading uppercase tracking-wider px-5 py-3 text-sm hover:bg-[#cc0029] transition-colors">Suchen</button>
      </form>

      {loading && <div className="flex justify-center py-10"><Loader2 className="animate-spin text-[#ff0033]" /></div>}
      {!loading && searched && results.length === 0 && <p className="text-neutral-500">Keine Treffer.</p>}

      <div className="space-y-3" data-testid="pro-search-results">
        {results.map((r, i) => (
          <button key={`${r.booking_number}-${i}`} onClick={() => nav(`/pro/courses/${r.course_id}`)}
            className="w-full text-left bg-[#0F0F0F] border border-white/10 hover:border-[#ff0033]/50 transition-colors p-4 flex items-center justify-between gap-4">
            <div>
              <p className="font-heading text-lg text-white">{r.first_name} {r.last_name}</p>
              <div className="flex flex-wrap gap-x-4 gap-y-1 mt-1 text-xs text-neutral-400">
                {r.phone && <span className="flex items-center gap-1"><Phone size={12} className="text-[#ff0033]" /> {r.phone}</span>}
                {r.email && <span className="flex items-center gap-1 break-all"><Mail size={12} className="text-[#ff0033]" /> {r.email}</span>}
                {r.address && <span className="flex items-center gap-1"><MapPin size={12} className="text-[#ff0033]" /> {r.address}</span>}
              </div>
              <p className="text-neutral-500 text-xs mt-1">{r.course_name} · {fmtDateTime(r.start)}</p>
            </div>
            <ChevronRight size={18} className="text-neutral-600 shrink-0" />
          </button>
        ))}
      </div>
    </div>
  );
};

export default ProSearch;
